import React from "react";
import { ArrowRight, Sparkles, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

const HERO_IMAGE =
  "https://images.pexels.com/photos/7413848/pexels-photo-7413848.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function Hero() {
  return (
    <section
      id="home"
      className="relative pt-32 pb-20 md:pt-40 md:pb-24 overflow-hidden"
      data-testid="hero-section"
    >
      <div
        aria-hidden
        className="absolute -top-32 -right-24 w-[520px] h-[520px] rounded-full bg-brand-soft blur-3xl opacity-70"
      />
      <div
        aria-hidden
        className="absolute -bottom-24 -left-24 w-[420px] h-[420px] rounded-full bg-brand-surfaceAlt blur-3xl opacity-70"
      />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-7 stagger">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white border border-brand-border text-xs tracking-[0.16em] uppercase text-brand-primary font-semibold">
            <Sparkles size={14} /> People-first HR · Pune
          </div>
          <h1 className="mt-6 font-heading font-medium text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Hire Faster.
            <br />
            <span className="text-brand-primary">Build Better Teams.</span>
          </h1>
          <p className="mt-6 text-base sm:text-lg text-brand-muted max-w-xl leading-relaxed">
            Career Connect helps startups and growing companies hire the right talent —
            fast — while giving candidates the guidance they need to land the right role.
            We don’t just fill seats. We build teams and careers.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <Button
              asChild
              className="rounded-full bg-brand-primary text-white hover:bg-brand-primaryHover h-12 px-6 text-sm font-semibold shadow-sm hover:shadow-md transition-all hover:-translate-y-0.5"
              data-testid="hero-cta-primary"
            >
              <a href="#contact" className="inline-flex items-center gap-2">
                Hire Talent <ArrowRight size={16} />
              </a>
            </Button>
            <Button
              asChild
              variant="outline"
              className="rounded-full h-12 px-6 text-sm font-semibold border-brand-border bg-white hover:bg-brand-surfaceAlt text-brand-ink"
              data-testid="hero-cta-secondary"
            >
              <a href="#for-candidates">Career Guidance</a>
            </Button>
          </div>

          <p
            className="mt-5 inline-flex items-center gap-2 text-sm text-brand-muted"
            data-testid="hero-trust-line"
          >
            <ShieldCheck size={14} className="text-brand-primary" />
            Trusted by growing startups, small businesses and candidates.
          </p>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-brand-border/70 animate-fade-up">
            <img
              src={HERO_IMAGE}
              alt="Startup team collaborating around a table"
              className="w-full h-[420px] lg:h-[520px] object-cover"
              data-testid="hero-image"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-brand-ink/20 via-transparent to-transparent" />
          </div>
        </div>
      </div>
    </section>
  );
}
